import css from 'styled-jsx/css';

export default css.global`.top-intro {
  text-align: center;
  margin: 8rem 0 3rem;
  padding: 2rem 0;
}

.top-intro p {
  color: #4e4d4d;
  font-weight: 500;
  font-size: 2rem;
}

.top-intro p:nth-child(2) {
  width: 70%;
  margin: auto;
}

.top-intro p.main-title {
  color: #2f3483;
  font-size: 2.7rem;
  font-weight: 800;
}

/* .single-product .top-intro p.main-title {
  color: #21714b;
} */

.top-intro .cicod-btn {
  margin-top: 1rem;
  display: inline-block;
}

.table-features {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  border-radius: 15px;
  position: relative;
  padding: 1rem 2px;
}

.table-features.product-pricing {
  display: none;
}

.table-features table {
  border: 1px solid #bababa;
  border-collapse: collapse;
}

.table-features th.plan-head-desc {
  font-weight: normal;
  width: 20%;
  min-width: 250px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  vertical-align: top;
  height: 220px;
}

.table-features th.plan-head-desc:nth-child(2) {
  background: #ffe9e9;
}

.table-features th.plan-head-desc:nth-child(3) {
  background: #fff7f0;
}

.table-features th.plan-head-desc:nth-child(4) {
  background: #d6ecdc;
}

.table-features th.plan-head-desc .plan-head-desc-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 2rem 3rem;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  position: relative;
  overflow: hidden;
}

.table-features th.plan-head-desc:nth-child(2).featured {
  border: 1px solid #a13a3a;
}

.table-features th.plan-head-desc:nth-child(2).featured .badge-status {
  background-color: #a13a3a;
}

.table-features th.plan-head-desc:nth-child(3).featured {
  border: 1px solid #af7644;
}

.table-features th.plan-head-desc:nth-child(3).featured .badge-status {
  background-color: #af7644;
}

.table-features th.plan-head-desc:nth-child(4).featured {
  border: 1px solid #33a354;
}

.table-features th.plan-head-desc:nth-child(4).featured .badge-status {
  background-color: #33a354;
}

.table-features th.plan-head-desc .plan-head-desc-inner .cicod-btn {
  display: block;
  width: fit-content;
}

td.marker img {
  width: 25px;
}

.table-features table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  border-style: hidden;
}

.table-features tbody {
  box-shadow: 0 1px 0 1px #e4e4e4;
}

.table-features td {
  border-bottom: 1px solid #e4e4e4;
}

.wfm .table-features th.plan-head-desc {
  padding-top: 0;
}

.table-features th.plan-head-desc p {
  margin-bottom: 0;
}

.table-features p.plan-type {
  text-transform: capitalize;
  color: #424242;
  font-weight: 800;
  font-size: 2rem;
}

.table-features p.plan-desc {
  text-transform: capitalize;
  font-size: 1.3rem;
  font-weight: 600;
  color: #a7a7a7;
}

.table-features p.price {
  color: #252525;
  font-weight: 900;
  font-size: 2.8rem;
  margin-top: auto;
}

td.border-right,
th.border-right {
  border-right: 1px solid;
}

th.border-top {
  border-top: 1px solid;
}

td.border-bottom {
  border-bottom: 1px solid;
}

.wfm td.border-right,
.wfm th.border-right {
  border-right-color: #2f3483;
}

.wfm th.border-top {
  border-top-color: #2f3483;
}

.wfm td.border-bottom {
  border-bottom-color: #2f3483;
}

.table-features p.sub-type {
  color: #4d4d4d;
  font-size: 1.2rem;
  margin-bottom: auto !important;
  font-weight: 500;
}

th.head-features {
  vertical-align: unset;
  height: 220px;
  padding-left: 3rem;
  padding-right: 3rem;
  padding-bottom: 2rem;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  border: none;
  background-color: #f0f3f5;
}

th.head-features span.pick {
  color: #2f2e7c;
  font-size: 2.8rem;
  font-weight: 400;
  margin-bottom: auto;
  padding-top: 2rem;
}

th.head-features span.pick img {
  margin-left: 2rem;
}

th.head-features span:nth-child(2) {
  color: #2f2e7c;
  font-size: 2rem;
  padding-top: 3rem;
  border-top: 1px solid rgb(119, 119, 119);
}

.table-features td {
  padding: 1.3rem 2rem;
}

td.table-sub-head {
  background-color: #f6f9ff;
  color: #2f2e7c;
  text-transform: uppercase;
  font-weight: 600;
  padding: 0rem;
}

td.table-sub-head button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1.3rem 2rem;
  border: none;
  background-color: transparent;
  outline: 0;
}

.table-features th.plan-head-desc span.text {
  padding: 5px 15px;
  margin-top: 1rem;
  display: block;
  font-weight: 600;
}

.table-features td i {
  font-size: 2rem;
}

.text-info {
  color: #14acfb;
}

.table-features table .cicod-btn {
  display: inline-block;
  margin-top: 1rem;
}

.table-features th.featured {
  position: relative;
}

/* 

.table-features td.featured::after,
.table-features th.featured::after {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
}

.table-features td.featured::after {
  border-right: 2px solid #2f3483;
  border-left: 2px solid #2f3483;
}

.table-features td.featured.border-bottom::after {
  border-bottom: 2px solid #2f3483;
}

.table-features th.featured::after {
  border: 2px solid #2f3483;
  border-bottom: none;
} */

.faq-section {
  background-color: #f0f5fd;
  padding: 4rem 0;
  margin-top: 4rem;
}

.faq-section--container {
  display: flex;
  align-items: center;
}

.faq-section--container .qestions-section {
  width: 50%;
  padding: 2rem 0;
  margin-right: 3rem;
}

.faq-section--container .img-section {
  width: 40%;
  margin-left: auto;
}

.faq-section--container .img-section img {
  width: 100%;
}

.faq-section--container .qestions-section > p {
  text-align: center;
  font-size: 2.5rem;
  font-weight: bold;
  color: #21714b;
  margin: 2rem 0;
}

.Collapsible {
  margin-bottom: 2rem;
}

.faq-collapse-trigger p {
  margin-bottom: 0;
}

.faq-collapse-trigger {
  background-color: #ffffff;
  display: flex;
  align-items: center;
  border-radius: 5px;
  padding: 1.3rem 2rem;
  font-weight: bold;
  color: #4d4d4d;
  cursor: pointer;
}

.faq-collapse-trigger span {
  margin-left: auto;
}

.Collapsible__contentInner {
  padding: 1.3rem 2rem;
  background-color: #ffffff;
}

.bottom-hero {
  background-color: #2f2e7c;
  min-height: 300px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.bottom-hero p:first-child {
  margin-bottom: 0;
  font-weight: 900;
  text-align: center;
  max-width: 85%;
}

.bottom-hero p {
  font-size: 4rem;
  font-weight: 500;
}

.top-left-border-radius {
  border-top-left-radius: 15px;
}

.top-right-border-radius {
  border-top-right-radius: 15px;
}

.bottom-left-border-radius {
  border-bottom-left-radius: 15px;
}

.bottom-right-border-radius {
  border-bottom-right-radius: 15px;
}

.table-features th.plan-head-desc .cicod-btn {
  padding: 5px 15px;
}

.table-features th.plan-head-desc .cicod-btn-outline {
  margin-left: 1rem;
}

p.product-feature {
  margin-bottom: 0;
  display: flex;
  align-items: center;
  position: relative;
  font-size: 15px;
}

p.product-feature i:not(i.fa-caret-up) {
  font-size: 0.7rem;
  border: 2px solid #1292d6;
  border-radius: 50%;
  padding: 3px 5px;
  margin-left: 0.8rem;
  color: #14acfb;
}

p.product-feature i.fa-caret-up {
  color: #2f3483;
  position: absolute;
  left: 5px;
  top: 1.3rem;
  display: none;
}

p.product-feature i:hover {
  cursor: pointer;
}

p.product-feature span {
  position: absolute;
  background-color: #2f3483;
  color: #fff;
  padding: 0.4rem;
  border-radius: 5px;
  max-width: 150px;
  width: fit-content;
  font-size: 1rem;
  font-weight: 600;
  top: 2.4rem;
  left: 0;
  display: none;
  z-index: 1000;
}

p.product-feature i:hover ~ i.fa-caret-up,
p.product-feature i:hover ~ span {
  display: block;
}

.badge-status {
  color: #fff;
  padding: 0.3rem 1.6rem;
  font-weight: 600;
  font-size: 1rem;
  width: fit-content;
  border-bottom-left-radius: 5px;
  text-align: center;
  text-transform: uppercase;
  position: absolute;
  top: 0;
  right: 0;
}

.cta-cont .cicod-btn:nth-child(1) {
  margin-right: 1rem;
}

.cta-cont {
  margin-top: 2rem;
}

@media (max-width: 1199px) {
  .table-features th.plan-head-desc .cicod-btn-outline {
    margin-left: 1rem;
  }
}

@media (max-width: 991px) {
  .faq-section--container {
    flex-direction: column;
  }

  .faq-section--container .qestions-section {
    width: 100%;
    padding: 2rem 0;
    margin-right: 0;
    order: 2;
  }

  .faq-section--container .img-section {
    width: 100%;
    text-align: center;
    order: 1;
  }
}

@media (max-width: 767px) {
  .bottom-hero p {
    font-size: 2rem;
    text-align: center;
  }
  .top-intro p:nth-child(2) {
    width: 100%;
  }
}

@media (min-width: 1023px) {
  .top-intro {
    margin: 8rem 0;
  }

  .top-intro p.main-title {
    font-size: 3.5rem;
  }

  .table-features.product-pricing {
    display: block;
  }
}
`